import * as stepsService from '../services/stepsService';
import RouteActions from '../RouteActions.js';
import baseService from '../services/baseService';

export function redirect(params = {}) {
    const token = baseService.defaults.headers.common['X-User-Token'];
    return (dispatch) => {
        if (token) {
            stepsService.getCurrentStep().then((response) => {
                stepsService.redirectToCurrentStep(response.data.payload, params);
            });
        }
    };
}
